import { solveWord, trie } from "./solve.js";
import { puzzlesJson } from "../json/puzzles.json";
import { wordsJson } from "../json/words.json";
import { archive } from "./archive.js";
import { lib } from "./lib.js";
import { storage } from "./storage.js";

var chiddleApp = (function() //
{
    var word = "";
    var selectedTiles = [];
    var lastSelectedTileId = "";
    var topWords = [];
    var gameJson = null;
    var now = new Date();
    var todaysDate = "";
    var isSubmitted = false;
    var statGamesCompleted = 0;
    var statAveragePercentage = 0;
    var statCurrentStreak = 0;
    var statMaxStreak = 0;
    var statCompletedGames = [];
    var originalLetterPositions = [[0,1,2,3],[4,5,6,7],[8,9,10,11],[12,13,14,15]];
    var currentLetterPositions = originalLetterPositions;
    var hintsUsed = [];
    var games = [];
    
    var $logo = document.getElementById("logo");
    var $gameContainer = document.getElementById("container");
    var $archiveContainer = document.getElementById("archive-container");
    var $archivedPuzzleDetails = document.getElementById("archived-puzzle-details");
    var $archivedPuzzleNumber = document.getElementById("archived-puzzle-number");
    var $archivedPuzzleDate = document.getElementById("archived-puzzle-date");
    var $tiles = document.querySelectorAll(".guess-grid > .tile");
    var $clickEntryWord = document.getElementById("click-entry-word");
    var $btnStats = document.querySelectorAll(".btn-stats");
    var $btnHelp = document.querySelectorAll(".btn-help");
    var $btnSupport = document.querySelectorAll(".btn-support");
    var $btnToday = document.getElementById("btn-today");
    var $btnArchive = document.getElementById("btn-archive");
    var $btnResult = document.getElementById("btn-result");
    var $puzzleBtnOffset = document.getElementById("puzzle-btn-offset");
    var $btnSubmit = document.getElementById("btn-submit");
    var $btnRequestHint = document.getElementById("btn-request-hint");
    var $btnCloseHint = document.getElementById("btn-close-hint");
    var $btnHint = document.getElementById("btn-hint");
    var $btnRotateLeft = document.getElementById("btn-rotate-left");
    var $btnRotateRight = document.getElementById("btn-rotate-right");
    var $modalClose = document.querySelectorAll(`.Modal-module_closeIcon__TcEKb, 
        .buttons-closable button, 
        #btn-close-hint,
        #btn-submit-cancel`);
    var $btnSubmitPuzzle = document.getElementById("btn-submit-puzzle");
    var $maxScore = document.getElementById("max-score"); 
    var $tableScore = document.getElementById("table-score");    
    var $btnShareButton = document.getElementById("btn-share-result"); 
        
    var $hintText = document.getElementById("hint-text");

    var $statGamesCompleted = document.querySelectorAll(".stat-gamescompleted");
    var $statAveragePercentage = document.querySelectorAll(".stat-averagepercentage");
    var $statCurrentStreak = document.querySelectorAll(".stat-currentstreak");
    var $statMaxStreak = document.querySelectorAll(".stat-maxstreak");

    var $buttons = document.querySelectorAll("button");
    var $dialogs = document.querySelectorAll("dialog");
    var $dialogHelp = document.getElementById("dialog-help");

    var $statBar1 = document.getElementById("stat-bar-1");
    var $statBar2 = document.getElementById("stat-bar-2");
    var $statBar3 = document.getElementById("stat-bar-3");
    var $statBar4 = document.getElementById("stat-bar-4");
    var $statBar5 = document.getElementById("stat-bar-5");
    var $statBar6 = document.getElementById("stat-bar-6");
    var $statBar7 = document.getElementById("stat-bar-7");

    var $perfect1 = document.getElementById("perfect-1");
    var $perfect2 = document.getElementById("perfect-2");
    var $perfect3 = document.getElementById("perfect-3");
    var $perfect4 = document.getElementById("perfect-4");
    var $perfect5 = document.getElementById("perfect-5");

    var $resultScorePercentage = document.getElementById("result-score-percentage");
    var $myScore = document.getElementById("my-score");
    var $resultPuzzleNumber = document.getElementById("result-puzzle-number");
    var $resultScore = document.getElementById("result-score");
    var $resultScorePercentage = document.getElementById("result-score-percentage");
    var $percentageScore = document.getElementById("percentage-score");
    var $percentageContainer = document.getElementById("percentage-container");

    var $highestScoringWords = document.getElementById("highest-scoring-words");

    var $btnDarkModeOn = document.getElementById("btn-darkmode-on");
    var $btnDarkModeOff = document.getElementById("btn-darkmode-off");

    var $emailAddressText = document.querySelectorAll(".email-address-text");

    var $helpImageTiles = document.getElementById("help-image-tiles");
    var $helpImageScore = document.getElementById("help-image-score");

    var $keyboardEntryInput = document.getElementById("keyboard-entry-input");
    var $btnKeyboard = document.getElementById("btn-keyboard");
    var $btnSelector = document.getElementById("btn-selector");

    var $desktopHowToPlay = document.querySelectorAll(".desktop-htp");
    var $mobileHowToPlay = document.querySelectorAll(".mobile-htp");

    var $resultTitle = document.getElementById("result-title");
    var $resultHints = document.getElementById("result-hints");

    var $btnDropdownMenu = document.getElementById("btn-dropdown-menu");
    var $dropdownImage = document.getElementById("dropdown-image");
    var $dropdownMenuContent = document.getElementById("dropdown-menu-content");
    var $overlay = document.getElementById("overlay");

    window.isMobile = function() {
        return (window.matchMedia("(any-hover:none)").matches) 
    };

    Date.prototype.addDays = function(days) {
        var date = new Date(this.valueOf());
        date.setDate(date.getDate() + days);
        return date;
    }

    function setTodaysDate()
    {
        todaysDate = now.getFullYear() 
            + "-" + ('0' + (now.getMonth()+1)).slice(-2) 
            + "-" + ('0' + now.getDate()).slice(-2);
        
        todayFormatted = getFormattedDate(now);
    }

    function init()
    {
        bindEvents();
        loadStatsData();
        setMobileDesktop();
        loadSettings();
        setTodaysDate();
        loadGame(getTodaysGameNumber());
        loadSavedGameData();    
        loadStats();

        archive.updateCompletedGames(statCompletedGames);
        archive.initCalendar();
    }

    function getTodaysGameNumber()
    {
        var firstPuzzleDate = new Date(2025, 1, 17); // year, month (0-11), day
        var diffTime = Math.abs(now - firstPuzzleDate);
        var diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24)); 
        return diffDays + 1; // add 1 as puzzle 1 is on launch date
    }

    function loadStatsData()
    {
        var statsJson = storage.getStats();

        if (statsJson !== null)
        {
            var statsData = JSON.parse(statsJson); 
            
            statCompletedGames = statsData["completedGames"];
            statAveragePercentage = statsData["averagePercentage"];
            statCurrentStreak = statsData["currentStreak"];
            statGamesCompleted = statsData["gamesCompleted"];
            statMaxStreak = statsData["maxStreak"];
        }
    }

    function loadSettings()
    {
        var settingsJson = storage.getSettings();

        if (settingsJson !== null)
        {
            var settingsData = JSON.parse(settingsJson); 
            
            if (settingsData["darkmode"] == true) 
            {
                darkModeOn();
            }

            if (!window.isMobile())
            {
                if (settingsData["desktopmouse"] == true 
                    && $btnKeyboard.classList.contains("hide"))
                {
                    switchToSelectorInput();
                }
                else if ($btnSelector.classList.contains("hide"))
                {
                    switchToKeyboardInput();                
                }                
            }
            else {
                if (!isSubmitted)
                {
                    bindTileSelection();
                }
            }
        }
        else if (!window.isMobile())
        {    
            switchToKeyboardInput();            
        }
        else {
            if (!isSubmitted)
            {
                bindTileSelection();
            }
        }
    }

    function bindEvents() 
    {        
        bindTileSelection();

        document.addEventListener("click", function (e) 
        {
            if (e.target && !e.target.classList.contains("dropbtn")) 
            {                
                $dropdownMenuContent.classList.add("hide");
                $dropdownImage.src = "images/menu.svg";
                $overlay.classList.add("hide");
            }

            if (e.target && e.target.classList.contains("link-definition")) 
            {
                showDefinition(e.target);
            }            
        });
        
        $btnStats.forEach(x => x.addEventListener("click", function (e) 
        {
            showStats(e.target);
        }));

        $btnHelp.forEach(x => x.addEventListener("click", function (e) 
        {
            $dialogHelp.classList.remove("first-time");
            lib.openDialog('dialog-help');
        }));

        $btnSupport.forEach(x => x.addEventListener("click", function (e) 
        {
            lib.openDialog('dialog-support');
        }));
        
        $btnResult.addEventListener("click", function (e) 
        {
            displayResult('dialog-result', e.target);
        });

        $btnSubmit.addEventListener("click", function (e) 
        {
            showResult(e.target);
        });

        $btnHint.addEventListener("click", function (e) 
        {
            openHint(e.target);
        });     

        $btnRequestHint.addEventListener("click", function (e) 
        {
            showHint(e.target)
        });     

        $btnSubmitPuzzle.addEventListener("click", function (e) 
        {
            submitted(e.target);
        });        

        $modalClose.forEach(x => x.addEventListener("click", function (e) 
        {
            lib.closeDialog(e.target);
        }));    

        $btnShareButton.addEventListener("click", function (e) 
        {
            handleShare(e)
        });

        $btnDarkModeOn.addEventListener("click", function () 
        {
            darkModeOn();
            saveSettings();
        });

        $btnDarkModeOff.addEventListener("click", function () 
        {
            darkModeOff();
            saveSettings();
        });

        $dialogs.forEach(x => x.addEventListener("click", function (e) 
        {
            closeAllDialogs(e, x);
        }));

        $keyboardEntryInput.addEventListener("keyup", function (e) 
        {
            handleKeyboardInput(e);
        });

        $btnRotateLeft.addEventListener("click", function () 
        {
            rotate("left");
        });

        $btnRotateRight.addEventListener("click", function () 
        {
            rotate("right");
        });

        $btnKeyboard.addEventListener("click", function () 
        {
            switchToKeyboardInput();
            saveSettings();
        });

        $btnSelector.addEventListener("click", function () 
        {
            switchToSelectorInput();
            saveSettings();
        });
        
        for (var i = 0; i < $dialogs.length; i++) 
        {
            $dialogs[i].addEventListener('close', focusKeyboardEntry, false);
        }
        
        $buttons.forEach(x => x.addEventListener("click", function (e) 
        {
            focusKeyboardEntry();
        }));

        $btnToday.addEventListener("click", function () 
        {
            showPuzzle(getTodaysGameNumber());
        });

        $btnArchive.addEventListener("click", function (e) 
        {
            showArchive();
        });

        $btnDropdownMenu.addEventListener("click", function () 
        {
            if ($dropdownMenuContent.classList.contains("hide"))
            {
                $dropdownMenuContent.classList.remove("hide");
                $dropdownImage.src = "images/close.svg";
                $overlay.classList.remove("hide");
            }
            else 
            {
                $dropdownMenuContent.classList.add("hide");
                $dropdownImage.src = "images/menu.svg";
                $overlay.classList.add("hide");
            }
            
        });

        document.addEventListener("gameChangeEvent", function(e) {
            showPuzzle(e.detail.gameNumber);
        });

        document.addEventListener("refreshStatsEvent", function(e) {
            loadStatsData();
            loadSavedGameData();    
            loadStats();
        });
        
        const myDiv = document.querySelectorAll('.dialog-content');
        myDiv.forEach(x => x.addEventListener('click', (event) => event.stopPropagation()));
    }

    function bindTileSelection()
    {
        for (var i = 0; i < $tiles.length; i++) 
        {
            $tiles[i].addEventListener('click', selectTile, false);
        }
    }

    function showPuzzle(gameNumber)
    {
        loadGame(gameNumber);
        loadSavedGameData();    
        $archiveContainer.classList.add("hide");
        $gameContainer.classList.remove("hide");
        focusKeyboardEntry();
    }

    function showArchive()
    {   
        archive.updateCalendar();
        archive.refreshCalendar();

        $gameContainer.classList.add("hide");
        $archiveContainer.classList.remove("hide");
    }

    function setMobileDesktop()
    {
        if (!window.isMobile())
        {
            Array.from($desktopHowToPlay).forEach(function(el) 
            {
                el.classList.remove("hide");      
            });  

            Array.from($mobileHowToPlay).forEach(function(el) 
            {
                el.classList.add("hide");      
            });  

            switchToKeyboardInput();
        }
    }

    function switchToKeyboardInput()
    {
        document.body.classList.add("keyboardentry");
        $btnKeyboard.classList.add("hide");
        $btnSelector.classList.remove("hide");

        $keyboardEntryInput.classList.remove("hide");
        $clickEntryWord.classList.add("hide");
        focusKeyboardEntry();

        [].forEach.call($tiles, function(el) {
            el.removeEventListener('click', selectTile);
        });

        [].forEach.call($tiles, function(el) {
            el.addEventListener('click', focusKeyboardEntry);
        });

        unselectTiles();
    }

    function focusKeyboardEntry()
    {
        if (!window.isMobile() && $btnKeyboard.classList.contains("hide"))
        {
            $keyboardEntryInput.focus();
        }
    }

    function switchToSelectorInput()
    {
        document.body.classList.remove("keyboardentry");
        $btnSelector.classList.add("hide");
        $btnKeyboard.classList.remove("hide");

        $keyboardEntryInput.value = "";
        $keyboardEntryInput.classList.add("hide");
        $clickEntryWord.classList.remove("hide");

        [].forEach.call($tiles, function(el) {
            el.removeEventListener('click', focusKeyboardEntry);
        });

        if (!isSubmitted)
        {
            bindTileSelection();
        }
    }

    function unselectTiles()
    {
        word = "";
        $clickEntryWord.innerHTML = "";
        lastSelectedTileId = "";
        selectedTiles = [];

        Array.from($tiles).forEach(function(el) {
            el.classList.remove("tw");      
        });  
    }

    function clearTileFormatting()
    {
        unselectTiles();

        Array.from($tiles).forEach(function(el) 
        {
            el.classList.remove("p1", "p2", "p3", "p4", "p5", "p6", "p7", "p8");      
        });    
    }

    function rotate(direction)
    {
        clearTileFormatting();

        var gameLetterArr = currentLetterPositions;

        var newArr = (direction == "left") 
            ? gameLetterArr.map((val, index) => gameLetterArr.map(row => row[row.length-1-index]))
            : gameLetterArr.map((val, index) => gameLetterArr.map(row => row[index]).reverse())

        var letterArr = [];

        newArr.forEach(x => {
            x.forEach(y => {
                letterArr.push(gameJson["l"][y]);
            });
        });

        currentLetterPositions = newArr;

        var count = 0;
        [].forEach.call($tiles, function(el) {
            var letter = letterArr[count];
            var points = lib.getLetterPoints(letter);

            letter = letter == "Q" ? "QU" : letter;

            el.dataset.letter = letter;

            el.innerHTML = letter 
                + "<sub>" + points + "</sub>";
            
            el.classList.add("p" + points);

            count++;
        });
    }

    function closeAllDialogs(event, element)
    {
        if (event.target === element) 
        {
            element.close();
        }
    }

    function darkModeOn()
    {
        $btnDarkModeOn.classList.add("hide");
        $btnDarkModeOff.classList.remove("hide");

        [].forEach.call($emailAddressText, function(el) {
            el.src = "images/emailaddress-dark.png?v=1";
        });

        $helpImageTiles.src = "images/help-tiles-dark.png?v=1";
        $helpImageScore.src = "images/help-score-dark.png?v=1";

        document.body.classList.add("darkmode");
    }

    function darkModeOff()
    {
        $btnDarkModeOff.classList.add("hide");
        $btnDarkModeOn.classList.remove("hide");

        [].forEach.call($emailAddressText, function(el) {
            el.src = "images/emailaddress.png?v=1";
        });

        $helpImageTiles.src = "images/help-tiles.png?v=1";
        $helpImageScore.src = "images/help-score.png?v=1";

        document.body.classList.remove("darkmode");
    }

    function handleShare(e)
    {
        lib.handleShare(gameJson["n"], 
            $resultScorePercentage.innerHTML, 
            $myScore.innerHTML, 
            $maxScore.innerHTML, 
            hintsUsed.length, 
            getTopFoundWordNumbers());

        lib.closeDialog(e.target);
    }

    function clearPerfectGuideStars()
    {
        for (var i = 0; i < 5; i++)
        {
            var el = document.getElementById(`perfect-${i + 1}`);
                        
            el.classList.forEach(e => {            
                el.classList.remove("top1", "top2", "top3", "top4", "top5");
            });            
        }
    }

    function resetGame()
    {
        clearPerfectGuideStars();
        clearTileFormatting();
        $tableScore.innerHTML = "<tbody></tbody>";
        hintsUsed = [];
        isSubmitted = false;

        $myScore.innerHTML = 0;
        $percentageScore.innerHTML = 0;
                
        formatPercentageScore();

        // set things back from completed game state
        $btnSubmit.classList.remove("hide");
        $btnHint.classList.remove("hide");
        $btnResult.classList.add("hide");
        $puzzleBtnOffset.classList.add("hide");
        
        $keyboardEntryInput.disabled = false;
        $keyboardEntryInput.classList.add("hide");
        $btnKeyboard.classList.add("hide");
        $btnSelector.classList.add("hide");

        setMobileDesktop();
        loadSettings();
    }

    function getTopWordColour(word)
    {
        var star = 1;
        var wordPoints = 0;
        var points = [];
        
        for (var i = 0; i < 5; i++)
        {
            var wp = lib.getWordPoints(topWords[i]);

            if (i > 0 && wordPoints != wp)
            {
                wordPoints = wp;
                star = star + 1;
            }
            else if (i == 0)
            {
                wordPoints = wp;
            }

            if (topWords[i] == word)
            {
                return star;
            }
        }

        return star;
    }

    function colourPerfectGuideStars(topWords)
    {
        var star = 1;
        var wordPoints = 0;
        
        for (var i = 0; i < 5; i++)
        {
            var wp = lib.getWordPoints(topWords[i]);

            if (i > 0 && wordPoints != wp)
            {
                wordPoints = wp;
                star = star + 1;
            }
            else if (i == 0)
            {
                wordPoints = wp;
            }

            document.getElementById(`perfect-${i + 1}`).classList.add(`top${star}`);            
        }
    }

    function loadGame(gameNumber) 
    {        
        resetGame();

        [].forEach.call(puzzlesJson, function(g) 
        {
            if (g["n"] === gameNumber) 
            {
                gameJson = g;
            }
        });
        
        // if (gameNumber == getTodaysGameNumber())
        // {
        //     $gameContainer.classList.remove("archived");
        //     $archivedPuzzleDetails.classList.add("hide");
        //     $archivedPuzzleNumber.innerHTML = "";
        //     $archivedPuzzleDate.innerHTML = "";
        // }
        // else {
            
            $gameContainer.classList.add("archived");
            $archivedPuzzleDetails.classList.remove("hide");
            $archivedPuzzleNumber.innerHTML = gameNumber;

            var dateOptions = { year: 'numeric', month: 'long', day: 'numeric' };
            var dateSplit = gameJson["d"].split("-");
            var gDate = new Date(dateSplit[0], dateSplit[1]-1, dateSplit[2]);

            $archivedPuzzleDate.innerHTML = gDate.toLocaleDateString("en-US", dateOptions);
        //}
        
        var count = 0;

        if (gameJson !== null)
        {
            [].forEach.call($tiles, function(el) 
            {
                var letter = gameJson["l"][count];
                var points = lib.getLetterPoints(letter);

                letter = letter == "Q" ? "QU" : letter;

                el.dataset.letter = letter;

                el.innerHTML = letter 
                    + "<sub>" + points + "</sub>";
                
                el.classList.add("p" + points);

                count++;
            });

            topWords = lib.getTopWords(gameJson);

            colourPerfectGuideStars(topWords);
            
            $maxScore.innerHTML = gameJson["p"];
        }
    }

    function loadStats() {
        $statGamesCompleted.forEach(function (e) 
        {
            e.innerHTML = statGamesCompleted;
        });

        $statAveragePercentage.forEach(function (e) 
        {
            e.innerHTML = statAveragePercentage;
        });

        $statMaxStreak.forEach(function (e) 
        {
            e.innerHTML = statMaxStreak;
        });

        var total = statCompletedGames.length;

        var bar1 = 0;
        var bar2 = 0;
        var bar3 = 0;
        var bar4 = 0;
        var bar5 = 0;
        var bar6 = 0;
        var bar7 = 0;

        var lastCompletedDate = null;

        statCompletedGames.forEach(function (g) 
        {
            var percentage = parseInt(g["percentage"]);

            if (lastCompletedDate == null || lastCompletedDate < g["gameDate"])
            {
                lastCompletedDate = g["gameDate"];
            }

            if (percentage < 50) 
            {
                bar1++;
            }
            else if (percentage >= 50 && percentage < 60)
            {
                bar2++;
            }
            else if (percentage >= 60 && percentage < 70)
            {
                bar3++;
            }
            else if (percentage >= 70 && percentage < 80)
            {
                bar4++;
            }
            else if (percentage >= 80 && percentage < 90)
            {
                bar5++;
            }
            else if (percentage >= 90 && percentage < 100)
            {
                bar6++;
            }
            else if (percentage == 100)
            {
                bar7++;
            }
        });

        var date = new Date();
        date.setDate(date.getDate() - 1);

        var dateFormatted = date.getFullYear() 
            + "-" + ('0' + (date.getMonth()+1)).slice(-2) 
            + "-" + ('0' + date.getDate()).slice(-2);

        if (lastCompletedDate != null 
            && lastCompletedDate != dateFormatted 
            && lastCompletedDate != todaysDate) 
        {
            statCurrentStreak = 0;
        }
        
        $statCurrentStreak.forEach(function (e) {
            e.innerHTML = statCurrentStreak;
        });

        // use a modifer to increase the bar to an appropriate size
        var modifier = 1;

        var bar1Percentage = 100 / total * bar1;
        var bar2Percentage = 100 / total * bar2;
        var bar3Percentage = 100 / total * bar3;
        var bar4Percentage = 100 / total * bar4;
        var bar5Percentage = 100 / total * bar5;
        var bar6Percentage = 100 / total * bar6;
        var bar7Percentage = 100 / total * bar7;

        var highestVal = Math.max(bar1Percentage, bar2Percentage, bar3Percentage, bar4Percentage, 
            bar5Percentage, bar6Percentage, bar7Percentage);

        if (highestVal < 75 && highestVal >= 50)
        {
            modifier = 1.25
        }
        else if (highestVal < 50 && highestVal >= 25)
        {
            modifier = 2
        }
        else if (highestVal < 25)
        {
            modifier = 3.5;
        }

        // get the highest bar value, and then use a switch to set an appropriate modifier

        if (bar1 > 0) 
        {
            $statBar1.classList.add("stat-bar");
        }
        else 
        {
            $statBar1.classList.remove("stat-bar");
        }
        
        $statBar1.innerHTML = bar1;
        $statBar1.style.width = (bar1Percentage * modifier) + "%";

        if (bar2 > 0) 
        {
            $statBar2.classList.add("stat-bar");
        }
        else 
        {
            $statBar2.classList.remove("stat-bar");
        }

        $statBar2.innerHTML = bar2;
        $statBar2.style.width = (bar2Percentage * modifier) + "%";

        if (bar3 > 0) 
        {
            $statBar3.classList.add("stat-bar");
        }
        else 
        {
            $statBar3.classList.remove("stat-bar");
        }

        $statBar3.innerHTML = bar3;
        $statBar3.style.width = (bar3Percentage * modifier) + "%";

        if (bar4 > 0) 
        {
            $statBar4.classList.add("stat-bar");
        }
        else 
        {
            $statBar4.classList.remove("stat-bar");
        }

        $statBar4.innerHTML = bar4;
        $statBar4.style.width = (bar4Percentage * modifier) + "%";

        if (bar5 > 0) 
        {
            $statBar5.classList.add("stat-bar");
        }
        else 
        {
            $statBar5.classList.remove("stat-bar");
        }

        $statBar5.innerHTML = bar5;
        $statBar5.style.width = (bar5Percentage * modifier) + "%";

        if (bar6 > 0)
        {
            $statBar6.classList.add("stat-bar");
        }
        else 
        {
            $statBar6.classList.remove("stat-bar");
        }

        $statBar6.innerHTML = bar6;
        $statBar6.style.width = (bar6Percentage * modifier) + "%";

        if (bar7 > 0) 
        {
            $statBar7.classList.add("stat-bar");
        }
        else 
        {
            $statBar7.classList.remove("stat-bar");
        }

        $statBar7.innerHTML = bar7;
        $statBar7.style.width = (bar7Percentage * modifier) + "%";
    }

    function showStats()
    {
        lib.openDialog("dialog-stats")
    }

    function handleKeyboardInput(e)
    {
        if (e.key === "Enter")
        {            
            word = e.currentTarget.value.toUpperCase();
            submitWord();
            word = "";

            e.currentTarget.value = "";
        }

        var currentWord = e.currentTarget.value;

        var word2 = currentWord.replace(/[^A-Za-z]/g, '');

        e.currentTarget.value = word2;
        
    }

    // tap the letters in order, and tap the last letter a second time to enter the word
    function selectTile(e)
    {        
        var el = e.currentTarget;

        if (el.classList.contains("tw"))
        {
            submitWord();
            unselectTiles();
        }
        else 
        {
            var err = false;

            if (lastSelectedTileId != "")
            {
                var lastSelectedTileArr = lastSelectedTileId.split("-");
                var selectedTileArr = el.id.split("-");

                var lastX = parseInt(lastSelectedTileArr[1]);
                var nextX = parseInt(selectedTileArr[1]);
                var lastY = parseInt(lastSelectedTileArr[2]);
                var nextY = parseInt(selectedTileArr[2]);

                if (!((lastX === nextX
                        || lastX === nextX + 1
                        || lastX === nextX - 1)
                    &&
                    (lastY === nextY
                        || lastY === nextY + 1
                        || lastY === nextY - 1))
                )
                {
                    err = true;
                }
            }
            
            if (!err)
            {
                lastSelectedTileId = el.id;
                el.classList.add("tw");
                selectedTiles.push(el);
                word += el.dataset.letter;

                $clickEntryWord.innerHTML = word + "...";
            }
            else 
            {
                shakeTiles([el]);
            }
        }
    }

    function getTopFoundWords() {
        // get top five words in table, compare to topWords list - if any in, get position in topwords list (+1)
        var rows = $tableScore.getElementsByTagName('tr');

        var topFoundWords = [];

        for (var i = 0; i < rows.length; i++) 
        {
            var tds = rows[i].getElementsByTagName('td');
            
            var word = tds[0].getElementsByTagName('a')[0].innerHTML;

            if (topWords.includes(word)) {
                topFoundWords.push(word);
            }
        }
        
        return topFoundWords;
    }

    function getTopFoundWordNumbers() {
        var topFoundWords = getTopFoundWords();

        var topFoundWordNumbers = "";
        var topWordsIndexes = [];

        [].forEach.call(topFoundWords, function(word) 
        {
            topWordsIndexes.push(topWords.indexOf(word));
        });

        topWordsIndexes.sort((a, b) => a - b);

        [].forEach.call(topWordsIndexes, function(i) 
        {
            topFoundWordNumbers += (i + 1) + ",";
        });

        if (topFoundWordNumbers == "") {
            topFoundWordNumbers = "-"
        }
        else {
            topFoundWordNumbers = topFoundWordNumbers.substring(0, topFoundWordNumbers.length - 1);
        }

        return topFoundWordNumbers;
    }

    function showResult()
    {    
        var rows = $tableScore.getElementsByTagName('tr');

        if (rows.length == 0) {
            lib.openDialog("dialog-cantsubmit");            
        }
        else {
            lib.openDialog("dialog-submit");         
        }
    }

    function submitted(el)
    {
        lib.closeDialog(el);
        saveGame(true);
        updateStats();
        processSubmitted();
    }

    function updateStats()
    {
        //update variables        
        
        statGamesCompleted += 1;

        var newCompletedGame = "{\"gameNumber\":" + gameJson["n"] + ","
            + "\"gameDate\":\"" + gameJson["d"] + "\","
            + "\"percentage\":" + $percentageScore.innerHTML + ","
            + "\"score\":" + $myScore.innerHTML + "}";

        statCompletedGames.push(JSON.parse(newCompletedGame)); 
        archive.updateCompletedGames(statCompletedGames);

        if (gameJson["d"] === todaysDate)
        {
            statCurrentStreak += 1;

            if (statCurrentStreak > statMaxStreak)
            {
                statMaxStreak = statCurrentStreak;
            }
        }

        // work out average percentage from completed games arr
        var percentageTotal = 0;        

        statCompletedGames.forEach(function (cg) {
            percentageTotal += parseInt(cg["percentage"]);
        });

        if (percentageTotal > 0)
        {
            statAveragePercentage = Math.round(percentageTotal / statGamesCompleted);
        }

        storage.saveStats(statCompletedGames,
            statMaxStreak,
            statCurrentStreak,
            statAveragePercentage,
            statGamesCompleted);
        loadStatsData();
        loadStats();
    }

    function getFormattedDate(date)
    {        
        const yyyy = date.getFullYear();
        let dd = date.getDate();
        const month = date.toLocaleString('default', { month: 'long' });
        
        return month + " " + dd + ', ' + yyyy;
    }

    function displayResult(dialogId)
    {
        var scoreText = $myScore.innerHTML;
        var scoreInt = parseInt(scoreText);

        var maxScore = parseInt($maxScore.innerHTML);

        var scorePercentage =  Math.floor(100/maxScore * scoreInt);

        $resultHints.innerHTML = hintsUsed.length;
        $resultPuzzleNumber.innerHTML = gameJson["n"] + ".  " + getFormattedDate(new Date(gameJson["d"]));
        $resultScore.innerHTML = scoreText + "/" + maxScore.toString();
        $resultScorePercentage.innerHTML = scorePercentage.toString() + "%";
        
        var foundWords = getTopFoundWords();

        $highestScoringWords.querySelectorAll("tr").forEach(row => row.remove());
        
        var wordsAdded = 0;
        var lastWordPoints = 0;

        for (var i = 0; i < gameJson["a"].length; i++)
        {
            var word = lib.getWordFromId(gameJson["a"][i]);
            var points = lib.getWordPoints(word);

            if (wordsAdded >= 5 && points < lastWordPoints) {
                break;
            }

            var row = $highestScoringWords.insertRow(0);
                                
            var cell0 = row.insertCell(0);
            var cell1 = row.insertCell(1);
            var cell2 = row.insertCell(2);
            var cell3 = row.insertCell(3);

            cell0.innerHTML = (i + 1) + ".";
            
            if (foundWords.includes(word)) {
                cell1.innerHTML = "<span class=\"found-word\">" + word + "</span>";
            }
            else {
                cell1.innerHTML = word;
            }

            var definition = getDefinition(word);
                            
            // Add some text to the new cells:
            if (definition === "")
            {
                cell3.innerHTML = "";
            }
            else
            {
                cell3.innerHTML = definition;
            }

            cell2.innerHTML = points;

            wordsAdded++;  
            lastWordPoints = points;
        };

        sortTableByStringNumber($highestScoringWords, 0, 0);

        lib.openDialog(dialogId);
    }

    function formatPercentageScore()
    {
        var percentageScore = parseInt($percentageScore.innerHTML);
        var percentageContainer = $percentageContainer;

        var classList = percentageContainer.classList;
        
        while (classList.length > 0) {
            classList.remove(classList.item(0));
        }

        percentageContainer.classList.add("percentage-container");
        percentageContainer.classList.add(lib.getPercentageScoreClass(percentageScore));
    }

    function getDefinition(word)
    {        
        var definition = "";
        
        if (wordsJson !== undefined)
        {
            [].forEach.call(wordsJson, function(w) {
                if (w["w"] === word) 
                {
                    definition = w["d"];
                }
            });
        }

        return definition;
    }

    function loadSavedGameData()
    {
        var savedGameData = storage.getSavedGameData();

        if (savedGameData !== null)
        {
            var gd = JSON.parse(savedGameData);     
            
            games = gd["games"];
            
            archive.updateUserGames(games)
            
            loadUserGame()
        }
        else { 
            $dialogHelp.classList.add("first-time");
            setTimeout(function (){
                lib.openDialog('dialog-help');  
              }, 1500);             
        }
    }
    
    function loadUserGame()
    {
        games.forEach(gameData => 
        {
            if (gameData["gameNumber"] == gameJson["n"])
            {
                var hints = gameData["hints"];
            
                for (var i = 0; i < hints.length; i++) 
                {           
                    var hint = hints[i];

                    hintsUsed.push({hintPosition: hint["hintPosition"], letter: hint["letter"], word: hint["word"]});
                }            

                var foundWords = gameData["foundWords"];

                for (var i = 0; i < foundWords.length; i++) 
                {
                    var row = $tableScore.insertRow(0);
                            
                    // Insert new cells (<td> elements) at the 1st and 2nd position of the "new" <tr> element:
                    var cell1 = row.insertCell(0);
                    var cell2 = row.insertCell(1);

                    var definition = "";

                    [].forEach.call(gameJson["a"], function(wordId) 
                    {
                        var w = lib.getWordFromId(wordId);

                        if (w == foundWords[i]["word"]) 
                        {
                            definition = getDefinition(w);
                        }
                    });

                    // Add some text to the new cells:
                    if (definition === "")
                    {
                        cell1.innerHTML = foundWords[i]["word"];
                    }
                    else
                    {
                        cell1.innerHTML = "<a class=\"link-definition\" data-definition=\"" + definition 
                            + "\" href=\"javascript:;\">" 
                                + foundWords[i]["word"] 
                            + "</a>";
                    }
                    
                    if (topWords.includes(foundWords[i]["word"])) {
                        cell1.innerHTML += ` <i class="fa fa-star top${getTopWordColour(foundWords[i]["word"])}" title="A top scoring word!" />`;
                    }

                    cell2.innerHTML = foundWords[i]["points"];

                    if ($tableScore.rows.length >= 5)
                    {
                        $tableScore.classList.add("topfive");
                    }        
                }

                sortTable($tableScore, 0, 0);
                sortTableByStringNumber($tableScore, 1, 1);

                var maxScore = parseInt($maxScore.innerHTML);

                var limit = $tableScore.rows.length >= 5 ? 5 : $tableScore.rows.length;

                var totalScore = 0;

                for (var i = 0; i < limit; i++)
                {
                    totalScore += parseInt($tableScore.rows[i].cells[1].innerHTML);
                }

                $myScore.innerHTML = totalScore;
                $percentageScore.innerHTML = Math.floor(100 / maxScore * totalScore);
                
                formatPercentageScore();

                if (gameData["isSubmitted"] == "true")
                {
                    processSubmitted();
                }
                else if (maxScore == totalScore) 
                {
                    saveGame(true);
                    updateStats();
                    processSubmitted();
                }
            }
        });   
    }

    function processSubmitted()
    {
        isSubmitted = true;

        $btnSubmit.classList.add("hide");
        $btnHint.classList.add("hide");
        $btnResult.classList.remove("hide");
        $puzzleBtnOffset.classList.remove("hide");
        $keyboardEntryInput.disabled = true;

        [].forEach.call($tiles, function(el) {
            el.removeEventListener('click', selectTile);
        });

        $btnResult.click();
    }

    function saveGame(isSubmitted)
    {
        // find the game in the games array, if exists update, if not add
        var gameExists = false;

        var elements = $tableScore.getElementsByTagName('tr');

        var foundWords = [];

        if (elements.length > 0)
        {
            for (var i = 0; i < elements.length; i++) 
            {
                var tds = elements[i].getElementsByTagName('td');
                
                var word = tds[0].getElementsByTagName('a')[0].innerHTML;

                foundWords.push({ word: word, points: tds[1].innerHTML });
            }
        }

        var hints = [];

        if (hintsUsed.length > 0)
        {
            for (var i = 0; i < hintsUsed.length; i++) 
            {           
                var hint = hintsUsed[i];

                hints.push({hintPosition: hint["hintPosition"], letter: hint["letter"], word: hint["word"] });
            }
        }

        var gameValues = {
            gameNumber: gameJson["n"],
            isSubmitted: isSubmitted.toString().toLowerCase(),
            foundWords: foundWords,
            hints: hints
        };

        games.forEach((g, index) =>
        {
            if (g["gameNumber"] == gameJson["n"])
            {
                gameExists = true;

                games[index] = gameValues;
            }
        });

        if (!gameExists)
        {
            games.push(gameValues);
        }
        
        archive.updateUserGames(games);

        storage.saveGameData(games);
    }

    function saveSettings()
    {
        var darkModeOn = $btnDarkModeOn.classList.contains("hide");
        var desktopMouse = $keyboardEntryInput.classList.contains("hide");

        storage.saveSettings(darkModeOn, desktopMouse);
    }
        
    function submitWord()
    {
        var input = word;// document.getElementById("input-word").value.toUpperCase().trim();

        var validWord = false;

        [].forEach.call(gameJson["a"], function(wordId) 
        {
            var w = lib.getWordFromId(wordId);

            if (input == w) 
            {
                validWord = true;

                // check if word is already in table
                var isAlreadyFound = false;
                
                var elements = $tableScore.getElementsByTagName('tr');

                for (var i = 0; i < elements.length; i++) 
                {
                    var as = elements[i].getElementsByTagName('a');

                    if (as[0].innerHTML == word) 
                    {
                        isAlreadyFound = true;
                        break;
                    }
                }

                if (isAlreadyFound)
                {
                    lib.showAlert("Word already found");
                }
                else 
                {
                    var row = $tableScore.insertRow(0);
                    
                    // Insert new cells (<td> elements) at the 1st and 2nd position of the "new" <tr> element:
                    var cell1 = row.insertCell(0);
                    var cell2 = row.insertCell(1);
                    
                    var definition = getDefinition(input);

                    // Add some text to the new cells:
                    if (definition === "")
                    {
                        cell1.innerHTML = input;
                    }
                    else
                    {
                        cell1.innerHTML = "<a class=\"link-definition\" data-definition=\"" + definition 
                            + "\" href=\"javascript:;\">" + input + "</a>";
                    }

                    if (topWords.includes(input)) {
                        cell1.innerHTML += ` <i class="fa fa-star top${getTopWordColour(input)}" title="A top scoring word!" />`;
                    }

                    cell2.innerHTML = lib.getWordPoints(word);

                    if ($tableScore.rows.length >= 5)
                    {
                        $tableScore.classList.add("topfive");
                    }

                    sortTable($tableScore, 0, 0);
                    sortTableByStringNumber($tableScore, 1, 1);

                    var score = document.querySelector("#total-score span");

                    var limit = $tableScore.rows.length >= 5 ? 5 : $tableScore.rows.length;

                    var totalScore = 0;

                    for (var i = 0; i < limit; i++)
                    {
                        totalScore += parseInt($tableScore.rows[i].cells[1].innerHTML);
                    }

                    saveGame(false);                

                    countUp();
                    countUpPercentage();

                    if (!window.isMobile() && $btnKeyboard.classList.contains("hide"))
                    {
                        danceWord(input);
                    }
                    else 
                    {
                        danceTiles(selectedTiles);
                    }

                    // if top score reached, automatically submit 
                    if (parseInt($maxScore.innerHTML) == totalScore)
                    {
                        var currentScore = parseInt($percentageScore.innerHTML);
                        var interval = ((100 - currentScore) * 100) + 1500;

                        setTimeout(function (){  
                            $resultTitle.innerHTML = "Perfect!";
                            saveGame(true);
                            updateStats();
                            processSubmitted();
                        }, interval); 
                    }
                }
            }
        });

        if (!validWord)
        {
            if (!window.isMobile() && $btnKeyboard.classList.contains("hide"))
            {
                keyboardEntryError();
            }
            else 
            {
                shakeTiles(selectedTiles);
            }
        }
    }       

    function keyboardEntryError()
    {        
        $keyboardEntryInput.classList.add("blink");

        $keyboardEntryInput.addEventListener(
            "animationend",
            () => {
                $keyboardEntryInput.classList.remove("blink");
            },
            { once: true }
        );
    }

    function danceWord(word)
    {
        var w = word.replace('QU', 'Q');

        trie.add(w.toLowerCase() + "|");

        var wordObj = solveWord();

        var coords = wordObj[0].coords;

        var kbSelectedTiles = [];

        coords.forEach(c => {            
            var tile = document.getElementById("tile-" + (parseInt(c[0]) + 1) + "-" + (parseInt(c[1]) + 1));
            kbSelectedTiles.push(tile);
        });

        trie.reset();

        danceTiles(kbSelectedTiles);
    }

    function openHint() 
    {       
        if (hintsUsed.length === 0)
        {
            $hintText.innerHTML = "Are you sure you want to use a hint?<br><br>You can request up to <strong>3</strong> hints.<br><br>";
        }
        else {            
            displayHints();
        }

        lib.openDialog("dialog-hint");  
    }

    function displayHints() {
        var hintWords = [];

        for (var i = 0; i < hintsUsed.length; i++) 
        {           
            var hint = hintsUsed[i];

            hintWords.push(hint["word"]);
        }

        var foundWords = getFoundWords();

        var wordsLeft = 0;

        topWords.forEach(word => {
            if (!hintWords.includes(word) && !foundWords.includes(word))
            {
                wordsLeft++;
            }
        });

        if (wordsLeft == 0)
        {
            $btnRequestHint.classList.add("hide");
            $btnCloseHint.classList.add("primary-button")
            $btnCloseHint.innerHTML = "OK";
        }
        else
        {
            if (hintsUsed.length == 1)
            {
                $btnRequestHint.innerHTML = "Another Hint";
            }
            else if (hintsUsed.length == 2)
            {
                $btnRequestHint.innerHTML = "Final Hint";
            }
            else {
                $btnRequestHint.classList.add("hide");
                $btnCloseHint.classList.add("primary-button")
                $btnCloseHint.innerHTML = "OK";
            }
        }

        $hintText.innerHTML = "One of the highest scoring words you haven't found starts with the letter:<br><br>"

        wordsFound = getFoundWords();

        for (var i = 0; i < hintsUsed.length; i++) 
        {           
            var hint = hintsUsed[i];

            $hintText.innerHTML += (wordsFound.includes(hint["word"]) ? "<span class=\"found-word\">" + hint["word"] + "</span>" : hint["letter"]) + "<br>";
        }

        if (wordsLeft == 0)
        {
            $hintText.innerHTML += "<br><br>There are no other top words remaining."
        }
    }

    function getFoundWords()
    {
        var elements = $tableScore.getElementsByTagName('tr');
        var wordsFound = [];

        for (var i = 0; i < elements.length; i++) 
        {
            var tds = elements[i].getElementsByTagName('td');
            
            var word = tds[0].getElementsByTagName('a')[0].innerHTML;

            wordsFound.push(word);
        }

        return wordsFound;
    }

    function showHint(e) {            
        wordsFound = getFoundWords();

        var hintWords = [];

        for (var i = 0; i < hintsUsed.length; i++) 
        {           
            var hint = hintsUsed[i];

            hintWords.push(hint["word"]);
        }

        var letter = "";

        for (const word of topWords) {
            if (!wordsFound.includes(word) && !hintWords.includes(word)) {
                letter = word.substring(0, 1);

                hintsUsed.push({hintPosition: (hintsUsed.length + 1), letter: letter, word: word});

                // save game cookie (add hint to it)                
                saveGame(false);   

                break;
            }
        }

        displayHints();
    }

    function showDefinition(e) {
        var word = document.getElementById("definition-word");
        var definition = document.getElementById("definition-text");

        word.innerHTML = e.innerHTML;
        definition.innerHTML = e.getAttribute('data-definition');

        lib.openDialog("dialog3");    
    }

    function countUpPercentage() {
        var totalScore = 0;

        var limit = $tableScore.rows.length >= 5 ? 5 : $tableScore.rows.length;

        for (var i = 0; i < limit; i++)
        {
            totalScore += parseInt($tableScore.rows[i].cells[1].innerHTML);
        }

        var maxScore = parseInt($maxScore.innerHTML);

        var newPercentage = Math.floor(100 / maxScore * totalScore);

        var current = parseInt($percentageScore.innerHTML);

        // assume 2000(milliseconds) is time delay to complete all animations
        // determine time interval based on value of data-count
        var timeIntervalBeforeIncrement = 100;

        var interval = setInterval(increase, timeIntervalBeforeIncrement);

        function increase() 
        {
            $percentageScore.innerHTML = current++;

            if (current > newPercentage) 
            {
                clearInterval(interval);
                formatPercentageScore();
            }
        }
    }

    function countUp() {
        var elem = document.querySelector("#my-score");

        var totalScore = 0;

        var limit = $tableScore.rows.length >= 5 ? 5 : $tableScore.rows.length;

        for (var i = 0; i < limit; i++)
        {
            totalScore += parseInt($tableScore.rows[i].cells[1].innerHTML);
        }

        var current = parseInt(elem.innerHTML);

        // assume 2000(milliseconds) is time delay to complete all animations
        // determine time interval based on value of data-count
        var timeIntervalBeforeIncrement = 100;

        var interval = setInterval(increase, timeIntervalBeforeIncrement);

        function increase() 
        {
            elem.innerHTML = current++;

            if (current > totalScore) 
            {
                clearInterval(interval);
            }
        }
    }

    function sortTableByStringNumber(table, col, reverse) {
        var tb = table.tBodies[0], // use `<tbody>` to ignore `<thead>` and `<tfoot>` rows
            tr = Array.prototype.slice.call(tb.rows, 0), // put rows into array
            i;
        reverse = -((+reverse) || -1);
        tr = tr.sort(function (a, b) { // sort rows
            return reverse // `-1 *` if want opposite order
                * (a.cells[col].textContent.trim() // using `.textContent.trim()` for test
                    .localeCompare(b.cells[col].textContent.trim(), undefined, {numeric: true, sensitivity: 'base'})
                    );
        });
        for(i = 0; i < tr.length; ++i) tb.appendChild(tr[i]); // append each row in order
    }

    function sortTable(table, col, reverse) 
    {
        var tb = table.tBodies[0], // use `<tbody>` to ignore `<thead>` and `<tfoot>` rows
            tr = Array.prototype.slice.call(tb.rows, 0), // put rows into array
            i;
        reverse = -((+reverse) || -1);
        tr = tr.sort(function (a, b) { // sort rows
            return reverse // `-1 *` if want opposite order
                * (a.cells[col].textContent.trim() // using `.textContent.trim()` for test
                    .localeCompare(b.cells[col].textContent.trim())
                    );
        });
        for(i = 0; i < tr.length; ++i) tb.appendChild(tr[i]); // append each row in order
    }

    const DANCE_ANIMATION_DURATION = 500
    
    function shakeTiles(tiles) 
    {
        tiles.forEach(tile => 
        {
            tile.classList.add("shake");

            tile.addEventListener(
                "animationend",
                () => {
                    tile.classList.remove("shake")
                },
                { once: true }
            )
        });
    }

    function danceTiles(tiles) 
    {
        tiles.forEach((tile, index) => 
        {
            setTimeout(() => 
            {
                tile.classList.add("dance");

                tile.addEventListener(
                    "animationend",
                    () => {
                        tile.classList.remove("dance")
                    },
                    { once: true }
                );
            }, (index * DANCE_ANIMATION_DURATION) / 5)
        })
    }
   
    return {
        init
    };
})();

addEventListener("DOMContentLoaded", (event) => 
{
    chiddleApp.init();
});